module.exports = __webpack_public_path__ + "img/shopping-cart.dbaef82c.svg";